import {Component, HostListener, OnInit} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";
import {AuthGuard} from "../../../common/auth-guard.service";
import {CommonMessagesService} from "../../../services/common-messages.service";
import {FiltersService} from "../../../services/filters.service";
import {SortOrder} from "../../../model/sort-order";
import {DefaultAssetRepresentation} from "../../../model/default-asset-representation";
import {DefaultAssetRepresentationFilters} from "../../../model/filters/default-asset-representation-filters";
import {DefaultAssetRepresentationsService} from "../../../services/default-asset-representations.service";

@Component({
  selector: 'app-default-asset-representations',
  templateUrl: './default-asset-representations.component.html',
  styleUrls: ['./default-asset-representations.component.scss']
})
export class DefaultAssetRepresentationsComponent implements OnInit {

  public representations: DefaultAssetRepresentation[];
  public totalRepresentations: number;
  public loadingRepresentations: boolean;

  public rows = 10;
  public first = 0;
  public selected = [];

  public filtersVisible: boolean;
  public currentFilters: DefaultAssetRepresentationFilters;
  public filtersFilled: boolean;

  constructor(private defaultAssetRepresentationsService: DefaultAssetRepresentationsService,
              private i18n: TranslocoService,
              public authGuardService: AuthGuard,
              private commonMessagesService: CommonMessagesService,
              private filtersService: FiltersService<DefaultAssetRepresentationFilters>) {
    this.currentFilters = new DefaultAssetRepresentationFilters();
  }

  ngOnInit(): void {
    if (this.filtersService.getCurrentFilters(this.constructor.name) !== undefined) {
      this.filtersFilled = true;
    }
    this.representations = new Array(this.rows);
    Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
  }

  private loadRepresentations(offset: number, limit: number): void {
    this.loadingRepresentations = true;
    this.representations = new Array(this.rows);
    this.defaultAssetRepresentationsService.getDefaultAssetRepresentations(offset, limit, this.filtersService.getCurrentFilters(this.constructor.name) === undefined ? this.currentFilters : this.filtersService.getCurrentFilters(this.constructor.name))
      .subscribe(response => {
        this.representations = response.defaultAssetRepresentations;
        this.totalRepresentations = response.totalElements;
        this.loadingRepresentations = false;
      });
  }

  onPageChange(event): void {
    this.currentFilters.sortField = event.sortField;
    this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.loadRepresentations(event.first / event.rows, event.rows);
  }

  resetFilters(): void {
    this.currentFilters = new DefaultAssetRepresentationFilters();
    this.currentFilters.sortField = 'name';
    this.currentFilters.sortOrder = SortOrder.ASCENDING;
    this.filtersFilled = false;
    this.filtersService.setCurrentFilters(undefined, this.constructor.name);
    this.applyFilters(true);
  }

  applyFilters(reset?: boolean): void {
    this.first = 0;
    if (reset !== true) {
      this.filtersService.setCurrentFilters(this.currentFilters, this.constructor.name);
      this.filtersFilled = true;
    }
    this.loadRepresentations(this.first / this.rows, this.rows);
  }

  confirmAndDelete(representation: DefaultAssetRepresentation): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => {
      this.deleteRepresentation(representation.name);
    });
  }

  deleteRepresentation(name: string): void {
    this.defaultAssetRepresentationsService.deleteDefaultAssetRepresentation(name).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadRepresentations(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status);
    });
  }

  confirmAndDeleteSelected(): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => this.deleteSelected(), true);
  }

  deleteSelected(): void {
    if (this.selected.length === 0) {
      return;
    }
    const names = this.selected.map(item => item.name);

    this.defaultAssetRepresentationsService.deleteDefaultAssetRepresentations(names).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadRepresentations(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status, true);
    });
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.key === 'f') {
      this.filtersVisible = true;
    }
    if (event.key === 'Escape') {
      this.filtersVisible = false;
    }
  }

}
